export default "__VITE_ASSET__C77ruMwI__"